module.exports = __webpack_public_path__ + "media/images/pic/labels/a1_2a-0e439cf4103f61f9b2dc01cd400fcc6b.png";